"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.FA_SLC_CUSTOMIZE_SCHEDULE_CONTENT = exports.SEPTEMBER_EXPERIMENT_SLC_CUSTOMIZE_SCHEDULE_CONTENT = exports.CLASSIC_SLC_CUSTOMIZE_SCHEDULE_CONTENT = exports.SLC_CUSTOMIZE_SCHEDULE_CONTENT = void 0;
var FIRST_PAYMENT_MESSAGE = {
    POSITIVE_HEADER: 'Smart thinking!',
    POSITIVE_BODY: 'Mid-month payments typically align with most people’s paychecks.',
    NEGATIVE_HEADER: 'Are you sure?',
    NEGATIVE_BODY: 'We recommend choosing an earlier date, so you don’t have payments due back-to-back.'
};
var SECOND_PAYMENT_MESSAGE = {
    POSITIVE_HEADER: 'Smart thinking!',
    POSITIVE_BODY: 'Spacing out your payments helps smooth your cash flow.',
    NEGATIVE_HEADER: 'Heads up!',
    NEGATIVE_BODY: 'Your payments are pretty close together. We recommend spreading them out.'
};
var DEPOSIT = {
    TITLE: 'Deposit',
    SUBTITLE: 'When rent is due'
};
var FIRST_PAYMENT = {
    TITLE: '1st payment'
};
var SECOND_PAYMENT = {
    TITLE: '2nd payment',
    SUBTITLE: 'Paid with deposit'
};
var SLC_DEPOSIT = {
    TITLE: 'When your rent is due',
    SUBTITLE: 'Deposit'
};
var SLC_PAYMENT = {
    TITLE: 'Select a date'
};
exports.SLC_CUSTOMIZE_SCHEDULE_CONTENT = {
    HEADER: 'Customize your schedule',
    FIRST_TIME: 'First time using Flex',
    EACH_MONTH: 'Repeats month to month',
    SUB_HEADER: 'Get started by setting up your schedule. You can always adjust this later in the app.',
    CTA: 'Continue',
    ERROR_RP_ON: 'Choose date to continue',
    ERROR_RP_OFF: 'Choose both dates to continue',
    DEPOSIT: DEPOSIT,
    FIRST_PAYMENT: FIRST_PAYMENT,
    SECOND_PAYMENT: SECOND_PAYMENT,
    FIRST_PAYMENT_MESSAGE: FIRST_PAYMENT_MESSAGE,
    SECOND_PAYMENT_MESSAGE: SECOND_PAYMENT_MESSAGE,
    DISCLAIMER: ''
};
exports.CLASSIC_SLC_CUSTOMIZE_SCHEDULE_CONTENT = __assign(__assign({}, exports.SLC_CUSTOMIZE_SCHEDULE_CONTENT), { DEPOSIT: SLC_DEPOSIT, FIRST_PAYMENT: SLC_PAYMENT, HEADER: 'Customize your payment schedule', SUB_HEADER: 'Starting in {{date}}, this schedule will repeat month to month.', DISCLAIMER: 'How does Flex split my rent?' });
exports.SEPTEMBER_EXPERIMENT_SLC_CUSTOMIZE_SCHEDULE_CONTENT = __assign(__assign({}, exports.CLASSIC_SLC_CUSTOMIZE_SCHEDULE_CONTENT), { HEADER: 'Customize your schedule', SUB_HEADER: 'Set up your payment schedule by selecting a date for your second payment to Flex. Payment must be made by the end of the month so your rent bill can be paid the following month.' });
exports.FA_SLC_CUSTOMIZE_SCHEDULE_CONTENT = __assign(__assign({}, exports.CLASSIC_SLC_CUSTOMIZE_SCHEDULE_CONTENT), { SUB_HEADER: 'This will be your default schedule, but you’ll be able to adjust it each month as needed' });
